import { IStorage } from "./storage.interface";

export class LocalStorage implements IStorage {
    private keys: string[] = [];

    constructor() {
        //return MemoryProxyStorage.applyProxy(this, "SessionStorage") as SessionStorage;
    }
    

    public isSupported(): boolean {
        return true;
        // let result;
        // try {
        //     const key = "isSupportedSessionStorageKey";
        //     const value = "isSupportedSessionStorageValue";
        //     sessionStorage.setItem(key, value);
        //     if (sessionStorage.getItem(key) === value) {
        //         sessionStorage.removeItem(key);
        //         result = true;
        //     }
        // } catch (ex) {
        //     result = false
        // } finally {
        //     return result;
        // }
    }

    public getParsed<T>(key: string): T {
        try {
            return JSON.parse(localStorage.getItem(key));
        } catch (ex) {
            return null;
        }
    }

    public get(key: string): any {
        try {
            return localStorage.getItem(key);
        } catch (ex) {
            return null;
        }
    }

    public set(key: string, data: any): boolean {
        let success;
        try {
            localStorage.setItem(key, data);
            this.addKey(key);
            success = true;
        } catch (ex) {
            success = false;
        } finally {
            return success;
        }
    }

    public delete(key: string): boolean {
        let success;
        try {
            localStorage.removeItem(key);
            this.removeKey(key);
            success = true;
        } catch (ex) {
            success = false;
        } finally {
            return success;
        }
    }

    public clear(): boolean {
        let success;
        try {
            for (let key of this.keys) {
                this.delete(key);
            }
            return true;
            // sessionStorage.clear();
            // success = true;
        } catch (ex) {
            success = false;
        } finally {
            return success;
        }
    }

    getAllKeys(): string[] {
        return this.keys;
    }
    getAllItems(): any[] {
        const items = [];
        try {
            for (let key of this.keys) {
               items.push({key: key, val: this.get(key)})
            }
            return items;
        } catch (ex) {
            return items;
        } 
    }

    private addKey(expandKey: string): void {
        const index = this.keys.indexOf(expandKey);
        if (index === -1) {
            this.keys.push(expandKey);
        }
    }

    private removeKey(expandKey: string): void {
        const index = this.keys.indexOf(expandKey);
        if (index !== -1) {
            this.keys.splice(index, 1);
        }
    }
}